export default "__VITE_ASSET__a500d1ab__"